export const AUTH_SIGNUP_LOADING = 'AUTH_SIGNUP_LOADING';
export const AUTH_SIGNUP_SUCCESS = 'AUTH_SIGNUP_SUCCESS';
export const AUTH_SIGNUP_ERROR = 'AUTH_SIGNUP_ERROR';

export const AUTH_SIGNIN_LOADING = 'AUTH_SIGNIN_LOADING';
export const AUTH_SIGNIN_SUCCESS = 'AUTH_SIGNIN_SUCCESS';
export const AUTH_SIGNIN_ERROR = 'AUTH_SIGNIN_ERROR';


export const AUTH_RESET_MESSAGE = 'AUTH_RESET_MESSAGE';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';